import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const SiteHeader: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="bg-white dark:bg-aspen-twilight-teal shadow-sm">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img src="/aspen-logomark.webp" alt="Ask Aspen logo" className="h-6 w-auto sm:h-8" width={32} height={32} />
              <span className="ml-2 text-lg sm:ml-3 sm:text-xl font-semibold text-aspen-deep-eucalyptus dark:text-aspen-pearl">
                Ask Aspen
              </span>
            </Link>
          </div>
          <div className="hidden md:flex items-center space-x-6">
            <Link to="/how-it-works" className="text-aspen-deep-eucalyptus dark:text-aspen-pearl hover:text-aspen-sage-teal transition-colors">
              How It Works
            </Link>
            <Link to="/features" className="text-aspen-deep-eucalyptus dark:text-aspen-pearl hover:text-aspen-sage-teal transition-colors">
              Features
            </Link>
            <Link to="/pricing" className="text-aspen-deep-eucalyptus dark:text-aspen-pearl hover:text-aspen-sage-teal transition-colors">
              Pricing
            </Link>
            <Link to="/blog" className="text-aspen-deep-eucalyptus dark:text-aspen-pearl hover:text-aspen-sage-teal transition-colors">
              Blog
            </Link>
            <Link to="/faq" className="text-aspen-deep-eucalyptus dark:text-aspen-pearl hover:text-aspen-sage-teal transition-colors">
              FAQ
            </Link>
            <Link
              to="/app"
              className="text-aspen-deep-eucalyptus dark:text-aspen-pearl hover:text-aspen-sage-teal transition-colors"
            >
              Tasks
            </Link>
            <Link to="/account" className="bg-aspen-sage-teal hover:bg-aspen-sage-teal/90 text-white px-4 py-2 rounded-lg transition-colors">Account</Link>
          </div>
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="p-2 rounded-lg hover:bg-aspen-sage-teal/10 transition-colors"
              aria-label="Toggle navigation menu"
              aria-expanded={mobileMenuOpen}
            >
              <svg className="w-6 h-6 text-aspen-deep-eucalyptus dark:text-aspen-pearl" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {mobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
        {mobileMenuOpen && (
          <div className="md:hidden pb-4 space-y-2">
            <Link to="/how-it-works" className="block px-3 py-2 rounded-lg text-aspen-deep-eucalyptus dark:text-aspen-pearl hover:bg-aspen-sage-teal/10 transition-colors" onClick={() => setMobileMenuOpen(false)}>How It Works</Link>
            <Link to="/features" className="block px-3 py-2 rounded-lg text-aspen-deep-eucalyptus dark:text-aspen-pearl hover:bg-aspen-sage-teal/10 transition-colors" onClick={() => setMobileMenuOpen(false)}>Features</Link>
            <Link to="/pricing" className="block px-3 py-2 rounded-lg text-aspen-deep-eucalyptus dark:text-aspen-pearl hover:bg-aspen-sage-teal/10 transition-colors" onClick={() => setMobileMenuOpen(false)}>Pricing</Link>
            <Link to="/blog" className="block px-3 py-2 rounded-lg text-aspen-deep-eucalyptus dark:text-aspen-pearl hover:bg-aspen-sage-teal/10 transition-colors" onClick={() => setMobileMenuOpen(false)}>Blog</Link>
            <Link to="/faq" className="block px-3 py-2 rounded-lg text-aspen-deep-eucalyptus dark:text-aspen-pearl hover:bg-aspen-sage-teal/10 transition-colors" onClick={() => setMobileMenuOpen(false)}>FAQ</Link>
            <Link to="/about" className="block px-3 py-2 rounded-lg text-aspen-deep-eucalyptus dark:text-aspen-pearl hover:bg-aspen-sage-teal/10 transition-colors" onClick={() => setMobileMenuOpen(false)}>About</Link>
            <Link to="/app" className="block px-3 py-2 rounded-lg text-aspen-deep-eucalyptus dark:text-aspen-pearl hover:bg-aspen-sage-teal/10 transition-colors" onClick={() => setMobileMenuOpen(false)}>Tasks</Link>
            <Link to="/account" className="block px-3 py-2 rounded-lg bg-aspen-sage-teal text-white text-center transition-colors" onClick={() => setMobileMenuOpen(false)}>Account</Link>
          </div>
        )}
      </nav>
    </header>
  );
};

export default SiteHeader;
